module.exports = __webpack_public_path__ + "img/Close Button.8f54fbf5.svg";